import styled from 'styled-components';
// utils
import { formatToPrice } from 'lib/utils/format/number';
// styles
import { palette } from 'cds/styles';

/**
 * 사이드 클래스 가격
 * @param {object} props
 * @param {string} props.salePercent
 * @param {number} props.originPrice
 * @param {string} props.totalPrice
 */
const ClassPrice = ({ salePercent, originPrice, totalPrice }) => {
  const discountRate = salePercent ? salePercent.split('.')[0] : salePercent;

  return (
    <Layout>
      <div>
        <SalePer>{discountRate}% 할인</SalePer>
        <OriginPrice>{formatToPrice(originPrice)}원</OriginPrice>
      </div>
      <SalePrice>
        <strong>월 </strong>
        {totalPrice}
        <strong>원</strong>
      </SalePrice>
    </Layout>
  );
};

const Layout = styled.div`
  margin-bottom: 24px;
`;

// TODO PHP와 임시적으로 색상 통일되어있음
const SalePer = styled.strong`
  margin-right: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff4b4f;
`;

const OriginPrice = styled.span`
  margin-left: 6px;
  font-weight: 500;
  font-size: 14px;
  text-decoration: line-through;
  color: #b4b4b4;
`;

const SalePrice = styled.h2`
  display: block;
  margin-top: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  color: ${palette.black};

  & > strong {
    color: ${palette.black};
    font-weight: 500;

    &:first-child {
      font-size: 16px;
    }

    &:last-child {
      font-size: 20px;
    }
  }
`;

export default ClassPrice;
